import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Loader } from '../../components/Loader/Loader';
import { Bem } from '../Bem/Bem';

import './PageLoader.css';
import * as keyset from './PageLoader.i18n';

const i18n = i18nFactory(keyset);

const PageLoader: React.SFC<{}> = (): React.ReactElement<{}, string> => (
    <div className={'page-loader'}>
        <Loader cls={Bem.cls('page-loader', 'loader')} size={'l'} text={i18n('loading-text')} />
    </div>
);

export { PageLoader };
